var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "content klc-page" }, [
    _c("div", { staticClass: "klc-toolbar-card row-data" }, [
      _c(
        "div",
        { staticClass: "klc-toolbar-section klc-toolbar-section--filter" },
        [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "klc-filter-grid" },
            [
              _c("el-input", {
                staticClass: "klc-search-input",
                attrs: { placeholder: "Mã học sinh...", clearable: "" },
                on: { clear: _vm.handleSearch },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.handleSearch.apply(null, arguments)
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "append",
                    fn: function () {
                      return [
                        _c("el-button", {
                          attrs: { icon: "el-icon-search" },
                          on: { click: _vm.handleSearch },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.dataSearch.kidCode,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.dataSearch,
                      "kidCode",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "dataSearch.kidCode",
                },
              }),
              _c("el-input", {
                staticClass: "klc-search-input",
                attrs: { placeholder: "Tên học sinh...", clearable: "" },
                on: { clear: _vm.handleSearch },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.handleSearch.apply(null, arguments)
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "append",
                    fn: function () {
                      return [
                        _c("el-button", {
                          attrs: { icon: "el-icon-search" },
                          on: { click: _vm.handleSearch },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.dataSearch.kidName,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.dataSearch,
                      "kidName",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "dataSearch.kidName",
                },
              }),
              _c(
                "el-select",
                {
                  staticClass: "klc-filter-control",
                  attrs: { clearable: "", placeholder: "Tất cả sự kiện" },
                  on: { change: _vm.handleSearch },
                  model: {
                    value: _vm.dataSearch.eventType,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataSearch, "eventType", $$v)
                    },
                    expression: "dataSearch.eventType",
                  },
                },
                _vm._l(_vm.eventTypeList, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
              _c("el-date-picker", {
                staticClass: "klc-filter-control klc-date-picker",
                attrs: {
                  type: "date",
                  "value-format": "yyyy-MM-dd",
                  format: "dd-MM-yyyy",
                  clearable: "",
                  placeholder: "Từ ngày",
                },
                on: { change: _vm.handleSearch },
                model: {
                  value: _vm.dataSearch.fromDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataSearch, "fromDate", $$v)
                  },
                  expression: "dataSearch.fromDate",
                },
              }),
              _c("el-date-picker", {
                staticClass: "klc-filter-control klc-date-picker",
                attrs: {
                  type: "date",
                  "value-format": "yyyy-MM-dd",
                  format: "dd-MM-yyyy",
                  clearable: "",
                  placeholder: "Đến ngày",
                },
                on: { change: _vm.handleSearch },
                model: {
                  value: _vm.dataSearch.toDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataSearch, "toDate", $$v)
                  },
                  expression: "dataSearch.toDate",
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c("div", { staticClass: "klc-toolbar-divider" }),
      _c(
        "div",
        { staticClass: "klc-toolbar-section klc-toolbar-section--action" },
        [
          _vm._m(1),
          _c(
            "div",
            { staticClass: "klc-action-group" },
            [
              _c(
                "el-button",
                {
                  staticClass: "klc-action-button",
                  attrs: { icon: "el-icon-refresh" },
                  on: { click: _vm.resetSearch },
                },
                [_vm._v("\n          Đặt lại\n        ")]
              ),
            ],
            1
          ),
        ]
      ),
    ]),
    _c("div", { staticClass: "klc-table-card row-data" }, [
      _vm._m(2),
      _c(
        "div",
        { staticClass: "klc-table-wrapper" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "sk-table",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.eventList,
                border: "",
                "highlight-current-row": "",
                height: _vm.$tableMaxHeight || 700,
                "empty-text": "Chưa có lịch sử phù hợp",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "STT",
                  type: "index",
                  width: "55",
                  align: "center",
                  index: _vm.indexMethod,
                },
              }),
              _c("el-table-column", {
                attrs: { label: "Từ ngày", width: "120", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.formatDate(row.startDate || row.effectiveDate)
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Đến ngày", width: "120", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.formatEndDate(row.endDate))),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "kidCode",
                  label: "Mã HS",
                  width: "125",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "kidName",
                  label: "Học sinh",
                  "min-width": "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", { staticClass: "klc-student-name" }, [
                          _vm._v(_vm._s(row.kidName)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Sự kiện", width: "165", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            staticClass: "klc-tag",
                            attrs: {
                              type: _vm.eventTagType(row.eventType),
                              size: "small",
                              effect: "light",
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.eventLabel(row.eventType)) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Nội dung thay đổi", "min-width": "280" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", { staticClass: "klc-event-desc" }, [
                          _vm._v(_vm._s(_vm.eventDescription(row))),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Người thao tác",
                  "min-width": "140",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.actorLabel(
                                row.modifiedByName,
                                row.lastModifieBy
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Thời gian thao tác",
                  width: "165",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.formatDateTime(
                                row.lastModifieDate ||
                                  row.effectiveAt ||
                                  row.createdDate
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "klc-pagination" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.pageNumber,
              "page-sizes": _vm.$pageListDefaultNew,
              "page-size": _vm.maxPageItem,
              total: _vm.total,
              layout: "total, sizes, prev, pager, next, jumper",
            },
            on: {
              "update:currentPage": function ($event) {
                _vm.pageNumber = $event
              },
              "update:current-page": function ($event) {
                _vm.pageNumber = $event
              },
              "update:pageSize": function ($event) {
                _vm.maxPageItem = $event
              },
              "update:page-size": function ($event) {
                _vm.maxPageItem = $event
              },
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handlePageChange,
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "klc-card-head" }, [
      _c("div", [
        _c("p", { staticClass: "klc-card-title" }, [_vm._v("Bộ lọc tìm kiếm")]),
        _c("p", { staticClass: "klc-card-subtitle" }, [
          _vm._v(
            "\n            Tra cứu lịch sử học sinh: tạo mới, đổi trạng thái, chuyển lớp, chuyển nhóm...\n          "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "klc-card-head klc-card-head--compact" }, [
      _c("div", [
        _c("p", { staticClass: "klc-card-title" }, [_vm._v("Tác vụ nhanh")]),
        _c("p", { staticClass: "klc-card-subtitle" }, [
          _vm._v("Đặt lại bộ lọc về mặc định."),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "klc-card-head klc-table-head" }, [
      _c("div", [
        _c("p", { staticClass: "klc-card-title" }, [
          _vm._v("Danh sách lịch sử học sinh"),
        ]),
        _c("p", { staticClass: "klc-card-subtitle" }, [
          _vm._v(
            "\n          Ghi nhận các lần tạo mới, đổi trạng thái, chuyển lớp và chuyển nhóm của học sinh.\n        "
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }